import {Component, EventEmitter, Output} from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-menu',
  imports: [
    RouterLink
  ],
  templateUrl: './menu.component.html',
})
export class MenuComponent {

  @Output()
  onClose = new EventEmitter<void>();
}
